import { persistor } from 'src/state';

class LogoutService {
  static logout() {
    persistor.purge();
    localStorage.removeItem('accessToken');
    localStorage.removeItem('modules');
    localStorage.removeItem('typedUsername');
    window.location.replace('/');
  }
}
export default LogoutService;
